import SideBar from '@/components/SideBar/SideBar.vue'

export default SideBar